<template>
  <div class="cloud-chamber-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>凝结核效应：电离能 → 液滴</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Background Observation Surface -->
          <rect x="0" y="0" width="400" height="240" fill="#000" />
          
          <!-- Cloud Tracks -->
          <g v-for="t in tracks" :key="t.id">
            <path :d="t.path" fill="none" :stroke="t.color" :stroke-width="t.width" opacity="0.6">
               <animate attributeName="opacity" values="0.6;0" dur="2s" fill="freeze" />
            </path>
            <!-- Fading droplets -->
            <circle v-for="(p, i) in t.points" :key="i" :cx="p.x" :cy="p.y" :r="t.width" :fill="t.color" opacity="0.3">
               <animate attributeName="r" from="2" to="0" dur="1s" fill="freeze" />
            </circle>
          </g>

          <!-- Magnetic Field (Uniform Outward) -->
          <g opacity="0.1">
             <circle v-for="n in 12" :key="'m'+n" :cx="(n%4)*100 + 50" :cy="Math.floor(n/4)*80 + 40" r="5" fill="none" stroke="#00d2ff" />
             <circle v-for="n in 12" :key="'p'+n" :cx="(n%4)*100 + 50" :cy="Math.floor(n/4)*80 + 40" r="1" fill="#00d2ff" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电离粒子在过饱和蒸汽中留下液滴</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="primary" size="mini" @click="spawnTrack('alpha')">α 粒子 (粗短且弯曲小)</el-button>
             <el-button type="success" size="mini" @click="spawnTrack('beta')">β 粒子 (细长且易弯曲)</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>云室充满了**过饱和蒸汽**。当高能粒子穿过时，会使气体分子电离。这些离子作为**凝结核**，吸引周围的水蒸气形成雾滴，从而在空间留下肉眼可见的路径。通过路径的粗细和在磁场中的偏转方向，可以判断粒子的电荷与质量。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloudChamberViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      tracks: [],
      nextId: 0
    }
  },
  methods: {
    spawnTrack(type) {
      let track = {
        id: this.nextId++,
        points: [],
        path: "",
        color: type === 'alpha' ? '#ff4757' : '#2ed573',
        width: type === 'alpha' ? 4 : 1.5,
        startTime: Date.now()
      };

      let x = 0;
      let y = 50 + Math.random() * 140;
      let angle = (Math.random() - 0.5) * 0.5;
      let bending = type === 'alpha' ? 0.001 : 0.05; // Beta bends more easily in B field
      let length = type === 'alpha' ? 100 : 300;
      
      let d = `M ${x} ${y} `;
      for (let i = 0; i < length; i += 5) {
        x += Math.cos(angle) * 5;
        y += Math.sin(angle) * 5;
        angle += bending * (Math.random() * 0.5 + 0.5);
        track.points.push({ x, y });
        d += `L ${x} ${y} `;
      }
      track.path = d;
      this.tracks.push(track);
      
      // Cleanup old tracks
      setTimeout(() => {
        this.tracks = this.tracks.filter(t => t.id !== track.id);
      }, 3000);
    }
  }
}
</script>

<style scoped lang="scss">
.cloud-chamber-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
